import api, { apiSetup } from 'config/api';
import { totalsQuery, TotalsParams } from './useActionTotals';
import { useCachedResource } from './useCachedResource';

apiSetup(undefined);

interface CountryRef {
  id: number;
  name: string;
  code: string | null;
}

/** /actions/get_chart_data/ series used by the Home (fields camelCased by the API client). */
export interface ChartData {
  countryChart: { data: number[]; labels: string[]; codes: (string | null)[] };
  territoryChart: { id: number; name: string; count: number; countries: CountryRef[] }[];
  themeCountChart: { id: number; name: string; count: number }[];
  /** Acciones per chart category (or Subtema, when it has none), with the Subtema that sets its color. */
  categoryChart: { key: string; name: string; count: number; subtheme: number }[];
  total: number;
}

const cache = new Map<string, ChartData>();
const NO_DATA: ChartData = {
  countryChart: { data: [], labels: [], codes: [] },
  territoryChart: [],
  themeCountChart: [],
  categoryChart: [],
  total: 0
};

/** The chart series for `params` (same filters as the Acciones list), or `null` while they load. */
export const useChartData = (params: TotalsParams): ChartData | null => {
  const query = totalsQuery(params);
  return useCachedResource(cache, query, () => api.get<ChartData>(`/actions/get_chart_data/${query}`), NO_DATA);
};
